module.exports = __webpack_public_path__ + "img/team.10109fee.webp";